import React, { useState } from "react";
import { Link } from "react-router-dom";
import Button from "../common/Button";
import { portfolioData } from "../../data/portfolioData";
import VideoModal from "../portfolio/VideoModal";
import "./FeaturedWork.css";

const FeaturedWork = () => {
  const [selectedVideo, setSelectedVideo] = useState(null);
  const featuredProjects = portfolioData.slice(0, 3);

  const handleView = (project) => {
    setSelectedVideo(project);
  };

  const handleClose = () => {
    setSelectedVideo(null);
  };

  return (
    <section className="featured-section">
      <div className="container">
        <div className="section-header">
          <h2>Featured Projects</h2>
          {/* <p>Discover our most impactful video productions</p> */}
        </div>

        <div className="featured-grid">
          {featuredProjects.map((project) => {
            const thumbnail =
              project.thumbnail ||
              (project.videoId
                ? `https://img.youtube.com/vi/${project.videoId}/hqdefault.jpg`
                : null);

            return (
              <div key={project.id} className="featured-card">
                <div className="featured-image">
                  {thumbnail ? (
                    <img
                      src={thumbnail}
                      alt={`${project.title} video thumbnail`}
                      loading="lazy"
                      onError={(event) => {
                        event.currentTarget.style.display = "none";
                      }}
                    />
                  ) : (
                    <div className="thumbnail-placeholder">
                      Thumbnail unavailable
                    </div>
                  )}

                  <div className="featured-overlay">
                    <span className="category-badge">{project.category}</span>
                  </div>
                </div>

                <div className="featured-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>

                  <Button
                    variant="outline"
                    size="small"
                    onClick={() => handleView(project)}
                  >
                    View Project
                  </Button>
                </div>
              </div>
            );
          })}
        </div>

        <div className="featured-footer">
          <Link to="/portfolio">
            <Button variant="primary" size="medium">
              View All Projects
            </Button>
          </Link>
        </div>
      </div>

      {selectedVideo && (
        <VideoModal video={selectedVideo} isOpen={true} onClose={handleClose} />
      )}
    </section>
  );
};

export default FeaturedWork;
